<template>
  <v-app id="app">
    <div class="global-loader-cont" v-if="loader">
      <v-card color="primary" dark class="global-loader" id="global-loader">
        <v-card-text>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </div>

    <!-- APP UPDATE SNACKBAR -->
    <v-snackbar :timeout="-1" bottom right v-model="newversion_snackbar">
      {{ $t("global.new_version") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" class="darken-2" small v-bind="attrs" @click="refreshPage()">{{ $t("global.refresh") }}</v-btn>
      </template>
    </v-snackbar>

    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "my-master",

  data() {
    return {
      dialog: true
    }
  },

  created: function() {
    ///////////////////////////////////////////////////////////
    // AXIOS
    ///////////////////////////////////////////////////////////

    this.$checkAppVersion();

    axios.interceptors.request.use(
      (config) => {
        let url = config.url

        if (this.$store.getters["master/axiosHideLoader"]) {
          // Hide loader if "master/axiosHideLoader" is set to true
        } else {
          if (url.includes("pushnotification") !== false) {
            // Always hide loader if the request if from pushnotification
          } else {
            this.$store.dispatch("master/setLoader", true)
          }
        }

        // Headers
        config.headers["X-Locale"] = this.$getSetting("locale")
        config.headers["Vue-Check-Version"] = this.$store.getters["master/versionCheck"]
        config.headers["Vue-CertReg-App-Version"] = process.env.VUE_APP_VERSION

        this.$globalMessages("", "", false)
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    axios.interceptors.response.use(
      (response) => {
        // Hide Loader
        this.$store.dispatch("master/setLoader", false)
        this.$store.dispatch("master/setAxiosHideLoader", false)

        // Hide Global Messages
        // this.$globalMessages("", "", false);
        return response
      },
      (error) => {
        // Version mismatch - Reload page
        /*if (process.env.VUE_APP_VERSION && 419 === error.response.status) {
          window.location.reload(true)
        }*/

        // Form error messages
        if (
          422 === error.response.status ||
          410 === error.response.status ||
          412 === error.response.status ||
          413 === error.response.status ||
          406 === error.response.status
        ) {
          let errors = this.$formatErrorMessages(error.response.data.errors)
          this.$globalMessages(errors, "error", true, error.response.status, error.response.data.extras)
          window.scrollTo({ top: 0, behavior: "smooth" })
        }

        // Hide Loader
        this.$store.dispatch("master/setLoader", false)
        return Promise.reject(error)
      }
    )

    ///////////////////////////////////////////////////////////
    // ROUTES
    ///////////////////////////////////////////////////////////
    this.$router.beforeEach((to, from, next) => {
      // Hide Global Messages
      this.$globalMessages("", "", false)

      let module = to.meta.module
      let permissions = to.meta.permissions

      // increase route count
      this.$store.dispatch("master/increaseRouteCount")
      var routeCount = this.$store.getters["master/routeCount"]

      if (routeCount > 0) {
        this.$store.dispatch("master/setVersionCheck", true)
      }

      this.$setCurrentModule(module)

      if (this.user.id) {
        const hasPermission = this.routeCheck(permissions)

        if (hasPermission || module == "auth" || module == "errors") {
          this.$checkAppVersion();
          next()
        } else {
          this.$setCurrentModule(from.meta.module)
          this.routeFailed(false)
        }
      } else {
        this.$checkAppVersion();
        next()
      }
    })

    this.routeInit()

    ///////////////////////////////////////////////////////////
    // AUTH
    ///////////////////////////////////////////////////////////

    this.check()
  },

  computed: {
    loader: {
      get() {
        return this.$store.getters["master/loader"]
      },
      set(value) {
        this.$store.dispatch("master/setLoader", value)
      }
    },
    locale: {
      get() {
        let locale = this.$getSetting("locale")
        return locale ? locale : "no"
      },
      set(value) {
        if (value) {
          this.$updateSetting("locale", value)
          this.$i18n.locale = value
        }
      }
    },
    user: {
      get() {
        return this.$store.getters["auth/user"]
      }
    },
    newversion_snackbar: {
      get() {
        return this.$store.getters["master/newVersionSnackbar"]
      },
      set(value) {
        this.$store.dispatch("master/setNewVersionSnackbar", value)
      }
    }
  },

  watch: {
    locale: {
      handler: function(val, oldVal) {
        this.locale = val
      }
    }
  },

  methods: {
    refreshPage() {
      window.location.reload(true)
    },
    check() {
      let user = this.$store.getters["auth/localUser"]
      let vm = this

      if (this.$checkAllCookies() && user) {
        let access_token = this.$cookies.get(`${this.COOKIE_PREFIX}access_token`)

        vm.$setAuthorization(access_token)

        axios({
          method: "get",
          url: this.API_URL + "auth/user"
        })
          .then((res) => {
            let status = res.data.data.status
            let path = vm.$router.currentRoute.path

            vm.$init(user.accessToken, res.data.data)

            if (status == 3 && !path.endsWith("/forcechangepassword")) {
              this.$store.dispatch("master/setRouteCount", -1)
              this.$router.push("/auth/" + this.locale + "/forcechangepassword").catch(err => {})
            }

            if (vm.$router.currentRoute.path == "/" || vm.$router.currentRoute.path == "/app" || vm.$router.currentRoute.path == "/app/") {
              if (status == 1) {
                if (vm.$hasRole("system-developer") || vm.$hasRole("superuser")) {
                  this.$store.dispatch("master/setRouteCount", -1)
                  vm.$router.push(vm.BACKEND_URL + "/dashboard").catch(err => {})
                } else {
                  this.$store.dispatch("master/setRouteCount", -1)
                  vm.$router.push(vm.BACKEND_URL + "/my").catch(err => {})
                }
              }
            } else {
              vm.routeInit()
            }
          })
          .catch((err) => {
            if (err.response.status == 401) {
              vm.$clearCookies()
              vm.$store.dispatch("settings/reset", vm)
              vm.$store.dispatch("auth/logout", vm)
            }
          })
      } else {
        this.$clearCookies()
        this.$store.dispatch("settings/reset", this)
        localStorage.removeItem("__crrntUser")

        let path = vm.$router.currentRoute.path
        let fullPath = vm.$router.currentRoute.fullPath
        let segments = ["/f/", "/auth/", "/privacystatement"]
        let allowed = false

        for (let segment of segments) {
          if (path.startsWith(segment)) {
            allowed = true
          }
        }

        if (!allowed) {
          vm.$store.dispatch("master/setRouteCount", -1)
          vm.$router.push("/auth/no/login").catch(err => {})
        } else {
          vm.$router.push(fullPath).catch(err => {})
        }
      }
    },

    routeCheck(permissions) {
      let bool = false

      for (let i in permissions) {
        const permission = permissions[i]
        if (this.$can(permission) || permission == "all") {
          bool = true
        }
      }

      if (!bool && this.$hasRole("system-developer")) {
        bool = true
      }

      return bool
    },

    routeInit() {
      let module = this.$router.currentRoute.meta.module
      let permissions = this.$router.currentRoute.meta.permissions

      this.$setCurrentModule(module)

      if (this.user.id) {
        const hasPermission = this.routeCheck(permissions)

        if (!hasPermission) {
          this.routeFailed()
        }
      }
    },

    routeFailed(redirect = true) {
      let vm = this

      swal({
        title: this.$t("global.no_permission_title"),
        text: this.$t("global.no_permission_text"),
        icon: "error"
      }).then(function() {
        if (redirect) {
          if (vm.$hasRole("system-developer") || vm.$hasRole("superuser")) {
            vm.$store.dispatch("master/setRouteCount", -1)
            vm.$router.push(vm.BACKEND_URL + "/dashboard").catch(err => {})
          } else {
            vm.$store.dispatch("master/setRouteCount", -1)
            vm.$router.push(vm.BACKEND_URL + "/my").catch(err => {})
          }
        }
      })
    }
  }
}
</script>
